const getters = {
  hidden: state => state.user.hidden,
  userId: state => state.user.userId,
  userInfo: state => state.user.userInfo,
  roleId: state => state.user.roleId,
  userName: state => state.user.name,
  roleName: state => state.user.roleName,
  routes: state => state.permission.routes
}
export default getters
